import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../../utils/date-range-options";

import {
  SET_LOADING,
  FETCH_DATA_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  SET_UPDATES_LOADING,
  FETCH_FILTERS_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  SET_FILTERS_DIRTY,
  UPDATE_FILTERS,
  SET_DATES
} from "./agreementsAnalysisSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  updatesLoading: false,
  filters: {},
  chartData: {
    tableValues: [],
    tableLinks: [],
    rawDataLink: "",
    pieCharts: [],
    dataPoints: [],
    colHeaders: [],
    columns: []
  },
  tableData: {
    tableValues: [],
    tableLinks: [],
    rawDataLink: ""
  },
  selectedFilters: {}
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [FETCH_DATA_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [UPDATE_FILTERS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, ...payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
      selectedFilters: {
        ...initialState.selectedFilters,
        ...action.payload,
        agreement_date: action.payload.agreement_date.find((obj) => obj.isDefault),
        rejoin_after: action.payload.rejoin_after.find((obj) => obj.isDefault),
      }
    })
  },
  initialState
);
